// ============================================
// GLOBAL PROGRESS BAR — F52-D
// Barra fina animada en la parte superior de la app.
// Aparece automáticamente cuando hay requests en vuelo.
// Se monta una sola vez en Layout.jsx.
// ============================================

import { useState, useEffect } from 'react';
import { subscribe } from '../services/requestTracker';

const GlobalProgressBar = () => {
  const [active, setActive] = useState(0);
  const [visible, setVisible] = useState(false);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    return subscribe((count) => {
      if (count > 0) {
        // Requests activos → mostrar barra
        setFading(false);
        setVisible(true);
      } else {
        // Todos terminaron → fade out y luego ocultar
        setFading(true);
        const timer = setTimeout(() => {
          setVisible(false);
          setFading(false);
        }, 400);
        return () => clearTimeout(timer);
      }
    });
  }, []);

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      height: '6px',
      zIndex: 99999,
      background: 'rgba(0, 246, 237, 0.15)',
      overflow: 'hidden',
      opacity: fading ? 0 : 1,
      transition: 'opacity 0.4s ease-out',
      boxShadow: '0 0 8px rgba(0, 246, 237, 0.3)'
    }}>
      <div style={{
        height: '100%',
        width: '40%',
        background: 'linear-gradient(90deg, transparent, #00F6ED, #00F6ED, transparent)',
        animation: 'gp-slide 1.2s ease-in-out infinite',
        borderRadius: '2px',
        boxShadow: '0 0 12px rgba(0, 246, 237, 0.5)'
      }} />
      <style>{`
        @keyframes gp-slide {
          0%   { transform: translateX(-100%); }
          100% { transform: translateX(350%); }
        }
      `}</style>
    </div>
  );
};

export default GlobalProgressBar;